import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      {/* 外层全屏背景 */}
      <div
        className="min-h-screen w-full flex items-center justify-center"
        style={{ background: 'linear-gradient(135deg, #dce6f5 0%, #e8e0f0 50%, #f0e8f8 100%)' }}
      >
        {/* 手机壳容器 */}
        <div
          className="relative overflow-hidden"
          style={{
            width: 390,
            height: 844,
            borderRadius: 48,
            boxShadow: '0 32px 80px rgba(100,120,180,0.25), 0 0 0 10px #e0e0e8, 0 0 0 12px #c8c8d8',
            background: '#F5F7FA',
            flexShrink: 0,
          }}
        >
          {/* 顶部刘海 */}
          <div
            className="absolute top-0 left-1/2 -translate-x-1/2 z-50"
            style={{
              width: 120,
              height: 34,
              background: '#e0e0e8',
              borderRadius: '0 0 20px 20px',
            }}
          />
          {/* 页面内容区域 */}
          <div className="absolute inset-0 overflow-hidden flex flex-col" style={{ borderRadius: 48 }}>
            <BrowserRouter basename={__BASE_PATH__}>
              <div className="flex-1 h-full relative">
                <AppRoutes />
              </div>
            </BrowserRouter>
          </div>
        </div>
      </div>
    </I18nextProvider>
  );
}

export default App;
